export default {
	state: {
		loading: false
	},
	getters: {
		isLoading: state => state.loading
	},
	mutations: {
		setLoading: (state, status) => state.loading = status,
	},
	actions: {
		setLoading({ commit }, status) {
			commit('setLoading', status)
		},
	}
}